<template>
  <!-- 设备详情 -->
  <div class="equipDetails">
    <div class="details_content">
      <div class="details_left">
        <div class="equipInfo">
          <div>
            <el-image :src="dataForm.fileList.length > 0 ? imgurl + dataForm.fileList[0].url : '../../assets/img/morentupian.png' " class="equipInfoImg">
            <div slot="error">
              <img class="equipInfoImg" src="../../assets/img/morentupian.png" />
            </div>
          </el-image>
          </div>
          <div class="equipInfo_content">
            <div class="details_name">{{dataForm.equipmentName}}</div>
            <el-descriptions :column="1" :colon="false">
              <el-descriptions-item label-class-name="my-label" label="设备型号">{{dataForm.equipmentModel}}</el-descriptions-item>
              <el-descriptions-item label-class-name="my-label" label="预约次数">{{dataForm.testsNumber}}次</el-descriptions-item>
              <el-descriptions-item label-class-name="my-label" label="服务周期">收到样品后平均{{dataForm.serviceDays}}个工作日完成</el-descriptions-item>
          </el-descriptions>
            <div style="width: 300px">
              <el-button type="primary" class="clickLook" size="small" @click="toAppoint(dataForm)">立即预约</el-button>
            </div>
          </div>
        </div>
        <el-card class="details_box-card" shadow="never" v-if="dataForm.projectIntroduction">
          <div slot="header" class="clearfix">
            <div class="descicon"></div>项目简介
          </div>
          <div class="editorContent" v-html="dataForm.projectIntroduction">
          </div>
        </el-card>
        <el-card class="details_box-card" shadow="never" v-if="dataForm.sampleRequirements">
          <div slot="header" class="clearfix">
            <div class="descicon"></div>样品要求
          </div>
          <div class="editorContent" v-html="dataForm.sampleRequirements">
          </div>
        </el-card>
        <el-card class="details_box-card" shadow="never" v-if="dataForm.serviceGuarantee">
          <div slot="header" class="clearfix">
            <div class="descicon"></div>服务保障
          </div>
          <div class="editorContent" v-html="dataForm.serviceGuarantee">
          </div>
        </el-card>
        <el-card class="details_box-card" shadow="never" v-if="dataForm.frequentlyQuestionListJson">
          <div slot="header" class="clearfix">
            <div class="descicon"></div>常见问题
          </div>
          <div class="editorContent">
            <el-table :data="JSON.parse(dataForm.frequentlyQuestionListJson)" border>
              <el-table-column label="问" prop="question" width="300" />
              <el-table-column label="答" prop="answer" />
            </el-table>
          </div>
        </el-card>
        <el-card class="details_box-card" shadow="never" v-if="dataForm.testingInstructions">
          <div slot="header" class="clearfix">
            <div class="descicon"></div>检测须知
          </div>
          <div class="editorContent" v-html="dataForm.testingInstructions">
          </div>
        </el-card>
        <el-card class="details_box-card" shadow="never" v-if="dataForm.resultsDisplay">
          <div slot="header" class="clearfix">
            <div class="descicon"></div>结果展示
          </div>
          <div class="editorContent" v-html="dataForm.resultsDisplay">
          </div>
        </el-card>
      </div>
      <div class="details_right">
        <div class="descicon"></div>
        <span class="right_title">技术顾问</span>
        <div class="technical">
          <el-image
            :src="serviceQRCode ? serviceQRCode : '../../assets/img/morentupian.png' "
            class="lxfs"
          >
            <div slot="error">
              <img class="lxfs" src="../../assets/img/morentupian.png" />
            </div>
          </el-image>
          <br />{{dataForm.technicalAdvisorTextPrompts || '暂无提示文字'}}
        </div>
        <div class="my_ys">
          <div class="descicon"></div>
          <span class="right_title">我们的优势</span>
          <img class="ys" src="../../assets/img/ys.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {equipInfo} from "@/api/request"
export default {
  data () {
    return {
      imgurl: process.env.VUE_APP_FILE_API,
      serviceQRCode: localStorage.getItem('serviceQRCode'),
      dataForm: {}
    }
  },
  mounted () {
    equipInfo(this.$route.query.id).then(res=> {
      this.dataForm = res.data
    })
  },
  methods: {
    // 未登录时进入登录页，成功后继续打开当前设备的预约页面
    toAppoint(i) {
      const appointRoute = this.$router.resolve({
        path: "/appointPage",
        query: {
          id: i.id,
          type: this.$route.query.type ? this.$route.query.type : 0,
        },
      }).route.fullPath;
      if(this.$store.getters.token) {
        this.$router.push(appointRoute);
        return;
      }
      this.$router.push({
        path: "/login",
        query: {
          redirect: appointRoute,
        },
      });
    }
  }
}
</script>
<style>
.equipDetails .el-descriptions-item__label:not(.is-bordered-label) {
  width: 110px;
  color: #333;
  font-size: 14px;
  font-weight: 500;
}
.equipDetails .el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 20px;
}
</style>
<style scoped lang="scss">
.equipInfo {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  height: 350px;
  background: #ffffff;
  border-radius: 7px;
  padding: 20px;
  margin-bottom: 30px;
  margin-top: 70px;
  padding-left: 50px;
}
.equipInfoImg {
  width: 200px;
  height: 140px;
  text-align: center;
}
.equipInfo_content {
  margin-left: 80px;
}
.details_name {
  font-size: 30px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 30px;
  
}
.details_subname {
  // display: flex;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 25px;

}
.details_subname_name {
  width: 100px;
  float: left;
  height: 45px;
}
.details_subname_other {
  font-weight: 400;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.details_box-card {
  margin-bottom: 30px;
}
  .ys {
    width: 300px;
    margin-top: 20px;
  }
  .my_ys {
    margin-top: 30px;
  }
</style>